import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  ModalController,
} from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import { _setStorage } from "src/app/utils/local-storage";
import { ApiserviceService } from "../../../httpservice/apiservice.service";
import { AppService } from "../../../services/app.service";
import { CsErrorText } from "../customer-search/customer-search.const";
import { DeleteCustomerModalComponent } from "./delete-customer-modal/delete-customer-modal.component";
@Component({
  selector: "app-customer-search",
  templateUrl: "./customer-search.component.html",
  styleUrls: ["./customer-search.component.scss"],
})
export class CustomerSearchComponent implements OnInit {
  customerData: any;
  searchCus: any = "";
  searchType: string = "taxId"; // ค่าเริ่มต้นเป็นเลขประจำตัวผู้เสียภาษี
  filterData: any;
  showpage = false;
  userProfile = {
    user_id: "",
    user_bu: "",
    user_loc: "",
    user_role: "",
    user_module: "",
  };
  body = {
    getpagination: {
      pageid: "1",
      filter: "",
    },
  };
  page = 1;
  rowLimit = 10;
  allPages: any;
  firstPage = true;
  prevPage = true;
  nextPage = false;
  lastpage = false;
  loading = false;
  timer = null;
  response = null;
  constructor(
    private apiService: ApiserviceService,
    private router: Router,
    private modalController: ModalController,
    public loadingController: LoadingController,
    public alertController: AlertController,
    private appService: AppService
  ) {}
  ngOnInit() {
    // this.initialBuyerData();
  }
  ionViewDidEnter() {
    this.body = {
      getpagination: {
        pageid: this.page ? String(this.page) : "1",
        filter: this.getSearchFilter(),
      },
    };
    // this.initialBuyerData();
  }

  buyerDataValidate(response) {
    if (typeof response !== "object") {
      return { result: false, errmsg: CsErrorText.errDataValidation.th };
    }

    if (!response.hasOwnProperty("data")) {
      return { result: false, errmsg: CsErrorText.errDataValidation.th };
    }

    if (!response.hasOwnProperty("statusMessage")) {
      return { result: false, errmsg: CsErrorText.errDataValidation.th };
    }

    if (response.statusCode !== 200) {
      return { result: false, errmsg: response.statusMessage };
    }

    return { result: true, errmsg: "" };
  }

  async initialBuyerData() {
    const response = await this.apiService._post(
      this.apiService.apiUrl + this.apiService.getCustomerLists,
      this.body
    );
    console.log("this is buyer lists response", response);
    let valid = this.buyerDataValidate(response);
    try {
      if (!valid.result) {
        const alert = await this.alertController.create({
          cssClass: "my-custom-class",
          message: valid.errmsg,
        });
        await alert.present();
        this.loading = false;
      } else {
        this.customerData = response.data;
        this.allPages = Math.ceil(response.count / response.row_limit);
        console.log("All page", this.allPages);
        this.showpage = true;
        this.rowLimit = response.row_limit;
      }
    } catch (e) {
      this.loading = false;
      this.showpage = false;
      // this.ErrorMsg(errMsg.error)
    }
  }

  editCustomerData($event) {
    _setStorage("ActiveConfig", 2);
    _setStorage(STORAGE.editCusData, $event);
    this.router.navigate(["/customer-detail"], {
      queryParams: { id: $event.buyer_id },
    });
    // }
  }

  addNewCus() {
    this.router.navigate(["/customer-add"]);
  }

  filterBuyerType($event) {
    let type = "";
    switch ($event) {
      case "0":
        type = "บุคคลธรรมดา";
        break;
      case "1":
        type = "นิติบุคคล";
        break;
      case "2":
        type = "ต่างชาติ";
        break;
      case "3":
        type = "อื่นๆ";
        break;
    }
    return type;
  }

  getPlaceholder(): string {
    switch (this.searchType) {
      case 'taxId':
        return 'กรอกเลขประจำตัวผู้เสียภาษี';
      case 'phone':
        return 'กรอกเบอร์โทรศัพท์';
      case 'name':
        return 'กรอกชื่อ นามสกุล';
      default:
        return 'กรอกข้อมูลที่ต้องการค้นหา';
    }
  }

  getSearchFilter(): string {
    // สร้าง filter string ตามประเภทที่เลือก
    if (!this.searchCus) {
      return '';
    }
    // ส่งข้อมูลในรูปแบบ "type:value" เพื่อให้ backend สามารถแยกประเภทการค้นหาได้
    return `${this.searchType}:${this.searchCus}`;
  }

  async search() {
    this.customerData = null;
    this.showpage = false;
    this.loading = false;
    if (!this.searchCus || !this.searchType) {
      return;
    }
    this.page = 1;
    clearTimeout(this.timer);
    this.loading = true;
    const data = {
      getpagination: {
        pageid: "1",
        filter: this.getSearchFilter(),
      },
    };
    console.log({data:data})
    this.timer = setTimeout(async () => {
      const response = await this.apiService._post(
        this.apiService.apiUrl + this.apiService.getCustomerLists,
        data
      );
      try {
        if (response.statusCode === 200) {
          this.customerData = response.data;
          this.rowLimit = response.row_limit;
          this.allPages = Math.ceil(response.count / this.rowLimit);
          this.firstPage = this.prevPage = true;
          this.nextPage = this.lastpage = this.allPages === 1 ? true : false;
          this.showpage = true;
        } else {
          this.loading = false;
          this.showpage = false;
          this.ErrorMsg(response.statusMessage);
        }
      } catch (e) {
        this.loading = false;
        this.showpage = false;
        // this.ErrorMsg(errMsg.error)
      }
    }, 1500);
  }
  async getFirst() {
    const temp = this.page;
    const tempData = this.customerData;
    this.customerData = null;
    this.page = 1;
    console.log("Page", this.page);
    const body = {
      getpagination: {
        pageid: "1",
        filter: this.getSearchFilter(),
      },
    };

    try {
      this.apiService
        ._post(this.apiService.apiUrl + this.apiService.getCustomerLists, body)
        .then(async (res) => {
          console.log("[------res data pagination -----------]", res);
          if (res.statusCode === 200) {
            this.customerData = res.data;
            this.prevPage = this.firstPage = true;
            this.nextPage = this.lastpage = false;
            this.page = this.page;
            this.rowLimit = res.row_limit;
          } else {
            this.customerData = tempData;
            this.page = temp;
            this.loading = false;
            this.showpage = false;
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      this.loading = false;
      this.showpage = false;
      // this.ErrorMsg(errMsg.error)
    }
  }
  async getLast() {
    const temp = this.page;
    this.page = this.allPages;
    const tempData = this.customerData;
    this.customerData = null;
    console.log("Page", this.page);
    const body = {
      getpagination: {
        pageid: `${this.page}`,
        filter: this.getSearchFilter(),
      },
    };
    try {
      this.apiService
        ._post(this.apiService.apiUrl + this.apiService.getCustomerLists, body)
        .then(async (res) => {
          console.log("[------res data pagination -----------]", res);
          if (res.statusCode === 200) {
            this.customerData = res.data;
            this.prevPage = this.firstPage = false;
            this.nextPage = this.lastpage = true;
            this.rowLimit = res.row_limit;
          } else {
            this.customerData = tempData;
            this.page = temp;
            this.loading = false;
            this.showpage = false;
            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      this.loading = false;
      this.showpage = false;
      // this.ErrorMsg(errMsg.error);
    }
  }

  async getPage(numPage) {
    const temp = this.page;
    const tempData = this.customerData;
    this.customerData = null;
    this.page += numPage;
    const body = {
      getpagination: {
        pageid: `${this.page}`,
        filter: this.getSearchFilter(),
      },
    };
    try {
      this.apiService
        ._post(this.apiService.apiUrl + this.apiService.getCustomerLists, body)
        .then(async (res) => {
          console.log("[------res data pagination -----------]", res);

          if (res.statusCode === 200) {
            this.customerData = res.data;
            this.prevPage = this.firstPage = this.page === 1 ? true : false;
            this.nextPage = this.lastpage =
              this.page === this.allPages ? true : false;
          } else {
            this.customerData = tempData;
            this.page = temp;
            this.loading = false;
            this.showpage = false;

            this.ErrorMsg(res.statusMessage);
          }
        });
    } catch (error) {
      this.loading = false;
      this.showpage = false;
      // this.ErrorMsg(errMsg.error);
    }
  }

  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
        },
      ],
    });
    await alert.present();
  }
  async presentDeleteModal(id, name, taxId) {
    const modal = await this.modalController.create({
      component: DeleteCustomerModalComponent,
      cssClass: "my-custom-class",
      componentProps: {
        buyerId: id,
        buyerName: name,
        taxId: taxId,
      },
    });

    modal.onDidDismiss().then(async (res) => {
      if(res.data?.confirm) {
        this.search();
      }
      // this.initialBuyerData();
      this.appService.setActive(1);
     
    });
    return await modal.present();
  }
  checkaddress(item) {
    if (item.type_addr === "1") {
      return item.addr_info;
    } else if (item.type_addr === "2") {
      return item.addr_infoEN;
    }
  }
}
